import { IArtist } from 'shared/interfaces'

export const getArtistCreateRules = (artistList: IArtist[]) => ({
  artistName: {
    required: 'Artist Name is required.',
    validate: (value: string) =>
      artistList.find((item: IArtist) => item.name.toLowerCase() === value.toLowerCase()) &&
      'Artist Name has already been taken'
  },
  firstCreatedIn: { required: 'Origin is required.' }
})

const rules = {
  artistStepRules: {
    artistName: { required: 'Artist Name is required.' }
  },
  projectStepRules: {
    projectName: { required: 'Project Name is required.' },
    unit: { required: 'Unit is required.' }
  }
}

export default rules
